import React from "react";
import { Link } from "react-router-dom";
import useCart from "hooks/useCart";
import { classNameConditional } from "utils/commonMethods";
import { APP_ROUTES } from "constants/routes";
import { CartIcon } from "constants/icons";
import "components/BottomCartBar/BottomCartBar.css";
import Button from "components/Button/Button";

//Bottom bar which shows the number of items in cart and go to cart button.
function BottomCartBar() {
  const { cartTotalQuantities } = useCart();
  const componentTexts = window.appTexts.components.bottom_cart_bar;

  //Message to be shown.
  const messageText = `${
    componentTexts.message_prefix
  } ${cartTotalQuantities} ${
    cartTotalQuantities === 1
      ? componentTexts.message_item_single
      : componentTexts.message_item_multiple
  } ${componentTexts.message_suffix}`;

  return (
    <div
      className={
        "bottom-cart-bar outer-shadow " +
        classNameConditional(cartTotalQuantities, "show-bar")
      }
    >
      <div className="bottom-cart-bar__content">
        <p className="bottom-cart-bar__message">{messageText}</p>
        <Link
          to={APP_ROUTES.CART_PAGE.url}
          className="bottom-cart-bar__anchor-link"
        >
          <Button className="bottom-cart-bar__button-wrapper">
            <i className="bottom-cart-bar--icon">
              <CartIcon />
            </i>
            {componentTexts.button_text}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default BottomCartBar;
